import { IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureSetDraftListStyles {
  root?: IStyle;
  listView?: IStyle;
  listViewWrap?: IStyle;
  cardView?: IStyle;
  calloutContents?: IStyle;
  calloutHeader?: IStyle;
  calloutBody?: IStyle;
}

export interface IFeatureSetDraftListClassNames {
  root: string;
  listView: string;
  listViewWrap: string;
  cardView: string;
  calloutContents: string;
  calloutHeader: string;
  calloutBody: string;
}

export const featureSetDraftListStylesDefault = (theme: IH2OTheme): Partial<IFeatureSetDraftListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: '8px',
  },
  listView: {
    flex: 1,
    padding: 24,
    paddingRight: 18,
    backgroundColor: theme.palette?.white,
  },
  listViewWrap: {
    overflow: 'auto',
    height: '100%',
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  calloutHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    span: {
      fontWeight: FontWeights.semiBold,
    },
  },
});
